import { CHANGE_PASSWORD } from 'state/actionTypes';

export const changePassword = (oldPassword, newPassword) => ({
  type: CHANGE_PASSWORD,
  payload: { oldPassword, newPassword },
});
